import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { insurersQueryKeys } from "../query-keys/insurers.query-keys";

const getInsurers = async (): Promise<string[]> => {
	const { data } = await privateAxios.get<string[]>("/insurers");
	return data;
};

export const useGetInsurers = () => {
	return useQuery({
		queryKey: insurersQueryKeys.list(),
		queryFn: getInsurers,
	});
};
